import { css } from '@emotion/react'
import colors from '@mathflat/common/style/colors'

export const 담당권한불가 = () => {
  return (
    <div css={_css}>
      <p>
        담당 학생 선생님은 해당 기능을 사용할 수 없습니다.
        <br />
        관리자 선생님에게 권한 수정을 요청해주세요.
      </p>

      <p className="desc">
        (관리자 선생님이 ‘운영 관리 &gt; 선생님 관리’에서
        <br />
        ‘전체학생 선생님’로 권한 변경할 수 있습니다.)
      </p>
    </div>
  )
}

const _css = css`
  text-align: center;

  .desc {
    margin-top: 8px;
    font-size: 12px;
    color: ${colors.gray.$700};
  }
`
